import React from 'react';
import { createRoot } from 'react-dom/client';
import FitGuideRacks from './FitGuideRacks';

let previousWidth = window.innerWidth;
const breakpoint = 991;

const rootElement = document.getElementById('REACT_fitAssistant');
const rootElementMobile = document.getElementById('REACT_fitAssistantMobile');
let root;

const renderApp = () => {
  if (root) {
    root.unmount();
    root.innerHTML = '';
  }
  let fitGuideData = window._THULEDATA.FitGuideRacksData;

  if (rootElement && window.getComputedStyle(rootElementMobile).display === 'none') {
    root = createRoot(rootElement);
    root.render(<FitGuideRacks data={fitGuideData} />);
  } else if (rootElementMobile) {
    root = createRoot(rootElementMobile);
    root.render(<FitGuideRacks data={fitGuideData} />);
  }
};

const remountOnResize = (event) => {
  if (
    (previousWidth > breakpoint && event.target.innerWidth <= breakpoint) ||
    (previousWidth <= breakpoint && event.target.innerWidth > breakpoint)
  ) {
    renderApp();
    previousWidth = event.target.innerWidth;
  }
};

let timer;
window.addEventListener('resize', (event) => {
  clearTimeout(timer);
  timer = setTimeout(remountOnResize(event), 100);
});

renderApp();
